import "./css/homepage.css";

function Home() {
  return (
    <div className="container">
      <h1 className="title">
        <span className="init">Hi,</span>
        <span className="sec">I am Jay Prajapati</span>
      </h1>
      <h2 className="title2">Software engineer and front end web devloper</h2>
      <div className="container-fluid">
        <p className="para">
          I am inexperienced in realtime projects but,i have worked on some
          projecs like todo list using node js, food site using
          html,js,css,php.I am looking for an oportunity to work on real time
          projects. I have learned html,css,js,php,angular js,node js and
          mongodb. I can speak english,gujrati and hindi. My hobbies are
          watching tech videos,reading news,learning about new
          technology,reading articals about astronomy.
        </p>
      </div>
    </div>
  );
}

export default Home;
